import { saveAs } from 'file-saver';

import noImage from '../../../components/assets/noImage.svg';
import noImageBg from '../../../components/assets/noImageBg.svg';
import noImageIcon from '../../../components/assets/noImageIcon.svg';
import { throwError } from '../../../modules/error';
import { S3_BUCKET, myBucket } from '../config';

import type { DocumentData, DocumentSnapshot } from 'firebase/firestore';

export const uploadFile = (fileObject: FileList | null, name: string): void => {
  try {
    if (typeof fileObject === 'undefined') {
      throw new Error();
    } else if (fileObject === null) {
      throw new Error();
    }
    const blob = new Blob([fileObject[0]]);
    const params = {
      ACL: 'public-read',
      Body: blob,
      Bucket: S3_BUCKET,
      Key: name
    };
    myBucket.putObject(params).send((err) => {
      if (err) throwError(err);
    });
  } catch (e) {
    throwError(e);
  }
};

export const deleteFile = (name: string): void => {
  try {
    const s3 = myBucket;
    s3.deleteObject(
      {
        Bucket: S3_BUCKET,
        Key: name
      },
      (err) => {
        if (err) {
          throwError(err);
        }
      }
    );
  } catch (e) {
    throwError(e);
  }
};

export const downloadFileFromS3 = async (name: string): Promise<void> => {
  try {
    const awsS3Bucket = process.env.REACT_APP_AWS_S3_BUCKET ?? '';
    const path = `https://${awsS3Bucket}.s3.ap-northeast-1.amazonaws.com/${name}`;
    const response = await fetch(path);
    const blob = await response.blob();
    const text = name.match(/[0-9]{13}_|[0-9]{14}_/g);
    const filename = name.substring(
      text ? name.indexOf(text[0]) + text[0].length : 0
    );
    saveAs(blob, filename);
  } catch (e) {
    throwError(e);
  }
};

export const getLogo = async (
  companySnap: DocumentSnapshot<DocumentData>
): Promise<string> => {
  try {
    const s3 = myBucket;
    if (companySnap.data()?.logoId) {
      const image = await s3.getSignedUrlPromise('getObject', {
        Bucket: S3_BUCKET,
        Key: companySnap.data()?.logoId as string
      });
      return image;
    }
    return noImageIcon;
  } catch (e) {
    throwError(e);
    return noImageIcon;
  }
};

export const getIcon = async (
  userSnap: DocumentSnapshot<DocumentData>
): Promise<string> => {
  try {
    const s3 = myBucket;
    if (userSnap.data()?.iconId) {
      const image = await s3.getSignedUrlPromise('getObject', {
        Bucket: S3_BUCKET,
        Key: userSnap.data()?.iconId as string
      });
      return image;
    }
    return noImageIcon;
  } catch (e) {
    throwError(e);
    return noImageIcon;
  }
};

export const getBgImage = async (
  companySnap: DocumentSnapshot<DocumentData>
): Promise<string> => {
  try {
    const s3 = myBucket;
    if (companySnap.data()?.bgImgId) {
      const image = await s3.getSignedUrlPromise('getObject', {
        Bucket: S3_BUCKET,
        Key: companySnap.data()?.bgImgId as string
      });
      return image;
    }
    return noImageBg;
  } catch (e) {
    throwError(e);
    return noImageBg;
  }
};

export const getUserIcon = async (
  userSnap: DocumentSnapshot<DocumentData>
): Promise<string> => {
  try {
    const s3 = myBucket;
    if (userSnap.data()?.iconId) {
      const image = await s3.getSignedUrlPromise('getObject', {
        Bucket: S3_BUCKET,
        Key: userSnap.data()?.iconId as string
      });
      return image;
    }
    return noImageIcon;
  } catch (e) {
    throwError(e);
    return noImageIcon;
  }
};

export const getIssueImage = async (imageId: string): Promise<string> => {
  try {
    const s3 = myBucket;
    if (imageId) {
      const image = await s3.getSignedUrlPromise('getObject', {
        Bucket: S3_BUCKET,
        Key: imageId
      });
      return image;
    }
    return noImage;
  } catch (e) {
    throwError(e);
    return noImage;
  }
};

export const getMediaImage = async (
  imageId: string
): Promise<string | null> => {
  try {
    const s3 = myBucket;
    if (imageId) {
      const image = await s3.getSignedUrlPromise('getObject', {
        Bucket: S3_BUCKET,
        Key: imageId
      });
      return image;
    }
    return null;
  } catch (e) {
    throwError(e);
    return null;
  }
};

export const getNegotiationFile = async (fileId: string): Promise<string> => {
  try {
    const s3 = myBucket;
    if (fileId) {
      const file = await s3.getSignedUrlPromise('getObject', {
        Bucket: S3_BUCKET,
        Key: fileId
      });
      return file;
    }
    throw new Error('FileId is not found.');
  } catch (e) {
    throwError(e);
    return '';
  }
};
